"use client";
import {
  useComboboxStore
} from "../__chunks/42G2NDPP.js";
import {
  ComboboxContextProvider
} from "../__chunks/3L4UCDWT.js";
import "../__chunks/F6GOJSFF.js";
import "../__chunks/WH6Q5C3D.js";
import "../__chunks/X3TS2MQG.js";
import "../__chunks/53KINMNA.js";
import "../__chunks/FU7RTSEI.js";
import "../__chunks/URSEQETI.js";
import "../__chunks/J7UNXP2A.js";
import "../__chunks/SJ5YBTFK.js";
import "../__chunks/YIF72NQG.js";
import "../__chunks/GO53B7AR.js";
import "../__chunks/X5ETRS5D.js";
import "../__chunks/5UDX7WKK.js";
import "../__chunks/DTNGDFNU.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import "../__chunks/4R3V3JGP.js";

// src/combobox/combobox-provider.tsx
import { jsx } from "react/jsx-runtime";
function ComboboxProvider(props = {}) {
  const store = useComboboxStore(props);
  return /* @__PURE__ */ jsx(ComboboxContextProvider, { value: store, children: props.children });
}
export {
  ComboboxProvider
};
